import React from "react";
import { useRouter } from "next/router";
import styles from "./ElixirHero.module.scss";
import { getCDNImageUrl } from "@/utils/Common";
import { ELIXIR_URL } from "@/constastants/Constant";
import { appendUtmParams, resolveUtmParams } from "@/utils/utmParams";

const PANORAMA_IMAGES = [
  { src: "hero-panorama-left.webp", alt: "", side: true },
  {
    src: "hero-panorama.webp",
    alt: "Elixir order management dashboard",
    side: false,
  },
  { src: "hero-panorama-right.webp", alt: "", side: true },
];

function ElixirHero({ onRequestDemo = () => {} }) {
  const router = useRouter();

  const handleExploreElixir = () => {
    const utm = resolveUtmParams(router.query, { source: "website", medium: "elixir_page" });
    window.open(appendUtmParams(ELIXIR_URL, utm), "_blank", "noopener,noreferrer");
  };

  return (
    <section className={styles.hero}>
      {/* Text block */}
      <div className={styles.content}>
        <h1 className={styles.heading}>
          <span className={styles.brand}>Elixir: </span>
          AI Platform That Transforms Chemical Procurement &amp; Supply Chain
        </h1>

        <p className={styles.subhead}>
          Elixir is Elchemy&apos;s purpose-built platform harnessing AI in the
          chemical industry to eliminate pricing opacity, automate procurement,
          and optimise every layer of your supply chain. From enquiry to
          delivery.
        </p>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.outlineButton}
            onClick={onRequestDemo}
          >
            Request Live Demo
          </button>
          <button
            type="button"
            className={styles.filledButton}
            onClick={handleExploreElixir}
          >
            Explore Elixir
          </button>
        </div>
      </div>

      {/* Dashboard panorama strip — 3 screenshots auto-scrolling continuously.
          The image set is rendered twice so the marquee loops seamlessly. */}
      <div className={styles.panorama}>
        <div className={styles.panoramaTrack}>
          {[0, 1].map((dup) =>
            PANORAMA_IMAGES.map((img, i) => (
              <img
                key={`${dup}-${i}`}
                src={getCDNImageUrl(img.src)}
                alt={dup === 0 ? img.alt : ""}
                aria-hidden={dup === 1 || img.side ? "true" : undefined}
                className={`${styles.panoramaImage} ${
                  img.side ? styles.panoramaSide : styles.panoramaCenter
                }`}
                loading={dup === 0 && !img.side ? "eager" : "lazy"}
              />
            ))
          )}
        </div>
      </div>
    </section>
  );
}

export default ElixirHero;
